import { Lang } from '@domain/language-negotiation';

// getIsDev :: Lang -> boolean
export const getIsDev = (language: Lang): boolean => language === 'dev';
